// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"f35cceb7","453":"cbf3d786"}[chunkId] + ".chunk.js";
};